<template>
    <el-form-item :class="{getClassByCopy,'hidden':component.properties.sortType==='hidden','to-top':component.properties.sortType==='toTop'}" @mouseenter.stop.native="controlMouseOver(component, index)" @click.native="controlClick(component, index)" class="rc-flowing-water-run" :prop="getProp" :label="component.properties.sortType==='hidden' ? '' : labelParameter.labelName"  :title="component.name" :label-width="labelParameter.width">
      <div v-if="labelParameter.showSlot" :class="['control-label', labelParameter.className]" slot="label">{{labelParameter.labelName}}</div>
      <el-tooltip class="component-explain-tooltip" v-if="component.properties.componentExplain" :content="component.properties.componentExplain" placement="bottom-start">
        <span class="fa fa-question-circle"></span>
      </el-tooltip>
      <el-input :value="value"
                :title="value"
                :style="{width: inputWidth ? inputWidth + 'px' : '100%', maxWidth: '100%'}"
                :class="[inputWidth && Number(inputWidth) < 30 && 'clear-padding']"
                disabled/>
    </el-form-item>
</template>

<script>
import { componentMixin, calculationMixin, inputMixin } from './mixins'

export default {
  name: 'rc-flowing-water',
  mixins: [ componentMixin, calculationMixin, inputMixin ],
  props: ['component', 'value', 'index', 'labelParameter', 'tableCtrlKey'],
  methods: {
    initComponent () {
      if (!this.value) {
        this.getPrefix()
      }
    },
    getPrefix () {
      const componentExpression = this.component.properties.code.expression
      // 如果有归档id，那么就执行监听，否则走一次计算即可
      const expression = {
        'expression': this.component.properties.code.expression,
        'path': this.getCurrentPath(),
        'callback': this.coding
      }
      if (componentExpression.match(/\$\{(.*?)\}/)) {
        this.getCalculationValue(expression)
      } else {
        const {watchPath, watchArray} = this.getWatchObj(expression)
        this.getCalValue(expression.expression, watchPath, watchArray).then(this.coding)
      }
    },
    coding (value) {
      let prefix
      let definitionPrefix = this.component.properties.code.expression
      if (!this.component.properties.code.isPrefix) {
        // 如果不使用编码前缀编码
        prefix = definitionPrefix || ' '
      } else {
        prefix = value || ' '
      }
      this.$axios.get(`/form-api/runtime/serialNum/${this.component.archive.columnId}`, {params: {prefix, definitionPrefix}})
        .then((data) => {
          let temp = data.data.toString()
          this.update(temp.replace(prefix, value))
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/form/runtime/components/rc-flowing-water.vue